import { Button } from 'antd'
import * as api from '../lib/api'
import { useI18n } from '../i18n/I18nProvider'

export default function AppraisalPdfButton ({ appraisalId, status, canExport = true, size = 'small', type, className, children }) {
  const { t } = useI18n()
  const openPdf = () => {
    window.open(api.getAppraisalPdfUrl(appraisalId), '_blank', 'noopener,noreferrer')
  }

  const isPrimary = type === 'primary'
  const resolvedClassName = isPrimary
    ? ['tti-btn-primary-grey', className].filter(Boolean).join(' ')
    : className

  if (status !== 'completed' || !canExport) return null

  return (
    <Button size={size} type={isPrimary ? undefined : type} className={resolvedClassName} onClick={openPdf}>
      {children || t('common.pdf', 'PDF')}
    </Button>
  )
}
